import React from "react";
import { COUNTRY_FROM, countryName, flagOf } from "./analyticsModel.mjs";

/* The small pieces every section of the Analytics page shares. */

/* A property's colour square: remotion.io black, landing pages blue, booking page yellow. */
export function PropDot({ prop }) {
  return <span aria-hidden="true" className={`an-dot an-dot--${prop}`} />;
}

/* A stage chip, coloured by the stage's key (analytics.css). */
export function StageChip({ chip }) {
  if (!chip) return null;
  return <span className={`an-stage an-stage--${chip.key}`}>{chip.label}</span>;
}

/*
 * Where a visit came from, as a flag and (unless `flagOnly`) the country's name.
 * Visits from before countries were recorded show a faint dash that says so.
 */
export function Country({ code, flagOnly = false }) {
  if (!code) {
    if (flagOnly) return null;
    return (
      <span className="an-country is-none" title={`Countries are recorded from ${COUNTRY_FROM}`}>
        –
      </span>
    );
  }
  const name = countryName(code);
  return (
    <span className="an-country" title={name}>
      <span className="an-flagemoji" role="img" aria-label={name}>
        {flagOf(code)}
      </span>
      {!flagOnly && <span className="an-country__name">{name}</span>}
    </span>
  );
}

/* "[LinkedIn ad] dr-image-Q4-2026-broad", "[Tagged link] Prospect room", "google.com", "Direct". */
export function SourceCell({ view }) {
  return (
    <>
      {view.pill && <span className={`an-kindpill an-kindpill--${view.kind}`}>{view.pill}</span>}
      <span className={`an-src an-src--${view.kind}`}>{view.text}</span>
    </>
  );
}
